import { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Row } from '@guestyci/foundation/Layout';
import {
  ROOT,
  EXISTING_EMAIL,
  FORM,
  VERIFY_EMAIL,
  ACTIVATE,
  VERIFICATION_ERROR,
} from 'app/routes';
import selectAppState from 'app/store/selector';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import { mediaScreen } from 'app/Styles';
import RouteStep from 'app/components/RouteStep';
import useQueryParams from 'app/hooks/useQueryParams';

const useClasses = createStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      listStyle: 'none',
      position: 'relative',

      width: 'fit-content',
      marginBottom: '5.125rem',
      zIndex: 1,

      '&:after': {
        content: "''",
        position: 'absolute',
        top: '50%',
        width: '100%',
        height: '1px',
        backgroundColor: '#0F265C',
        zIndex: '-1',
      },

      [mediaScreen.md]: {
        display: 'none',
      },
    },
  }),
  { name: 'Bread-crumbs' }
);

// NOTE: element order and array matrix is important
const regularSignUpFlowCrumbs = [
  [ROOT, EXISTING_EMAIL],
  FORM,
  [VERIFY_EMAIL, VERIFICATION_ERROR],
  ACTIVATE,
];
const googleSignUpFlowCrumbs = [[ROOT, EXISTING_EMAIL], FORM, ACTIVATE];

function StepHeader() {
  const classes = useClasses();
  const { isGoogleSignUp } = useSelector(selectAppState);
  const urlParams = useQueryParams();
  const queryValues = {
    queryEmail: urlParams.get('email') || '',
    queryFirstName: urlParams.get('firstname') || '',
    queryLastName: urlParams.get('lastname') || '',
  };

  const crumbs = useMemo(
    () => (isGoogleSignUp ? googleSignUpFlowCrumbs : regularSignUpFlowCrumbs),
    [isGoogleSignUp]
  );
  const checkAllRequestedQueryValuesFilled =
    Boolean(queryValues.queryEmail) &&
    Boolean(queryValues.queryFirstName) &&
    Boolean(queryValues.queryLastName);
  const areAllRequestedQueryValuesFilled = useRef(checkAllRequestedQueryValuesFilled);

  return (
    <>
      {!areAllRequestedQueryValuesFilled.current && (
        <Row fullWidth justify="center">
          <ul className={classes.root} id="steps-container">
            {crumbs.map((route, index) => (
              <RouteStep
                key={route}
                to={route}
                step={index + 1}
                label="STEP"
                className={classes.item}
              />
            ))}
          </ul>
        </Row>
      )}
    </>
  );
}

export default StepHeader;
